import React, { useState } from 'react';
import { Camera, Check, Loader2, X } from 'lucide-react';

// Upload de UMA foto: sobe na hora (POST /upload-foto → SharePoint) e devolve a
// URL via callback. Compartilhado entre o Diagnóstico (Etapa 1), a Certificação
// (Etapa 2) e — desde 2026-09-03 — a Solicitação de Reparo. A decisão de "upload
// separado" (em vez de base64 no submit) vive aqui.
//
// ⚠️ O ENDEREÇO VEM DE FORA desde 2026-09-03 (prop `api`), com o da Certificação
// como padrão. Foi o que evitou a QUARTA cópia deste componente: a Solicitação
// de Reparo precisava do mesmo comportamento apontando para o próprio módulo
// (cada um grava na sua pasta do SharePoint e tem o seu recorte de perfil).
// Nada muda para quem já usava — as duas telas da Certificação não passam `api`.
// Isto NÃO fecha o card do PLANO de unificar as 3 cópias (BSV e Treinamento
// seguem separadas), mas tira a razão de existir uma quarta.
const API_PADRAO = '/api/manutencao/certificacao';
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('authToken')}` });

// `campos`: metadados extras do multipart, para o servidor montar o nome/pasta
// do arquivo. Genérico de propósito — a Certificação manda patrimônio/chave/slot,
// o Reparo manda loja/chave, e o componente não precisa conhecer nenhum dos dois.
const FotoUpload = ({ url, onUrl, label, patrimonio, chave, slot, api = API_PADRAO, campos }) => {
  const [estado, setEstado] = useState('idle'); // idle | enviando | erro
  const enviar = async (file) => {
    if (!file) return;
    setEstado('enviando');
    try {
      const fd = new FormData();
      fd.append('foto', file);
      // Metadados p/ o nome único no SharePoint (pasta por patrimônio + chave do relatório).
      if (patrimonio) fd.append('patrimonio', patrimonio);
      if (chave) fd.append('chave', chave);
      if (slot) fd.append('slot', slot);
      Object.entries(campos || {}).forEach(([k, v]) => { if (v) fd.append(k, v); });
      const r = await fetch(`${api}/upload-foto`, { method: 'POST', headers: auth(), body: fd });
      const data = await r.json();
      if (!r.ok) throw new Error(data?.message || 'Falha no upload.');
      onUrl(data.url);
      setEstado('idle');
    } catch (e) {
      setEstado('erro');
    }
  };
  // Remove a foto já anexada: limpa a URL no pai (volta a contar como "sem foto"
  // nas validações de obrigatoriedade) e zera qualquer estado de erro.
  const remover = () => { onUrl(''); setEstado('idle'); };

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      <label style={{
        display: 'inline-flex', alignItems: 'center', gap: 6, cursor: 'pointer',
        padding: '6px 10px', borderRadius: 6, fontSize: 12, fontWeight: 700,
        border: '1px solid', borderColor: url ? '#c7d2fe' : '#cbd5e1',
        background: url ? '#eef2ff' : '#fff', color: url ? '#4338ca' : '#475569',
      }}>
        {estado === 'enviando' ? <Loader2 size={14} className="spin" /> : url ? <Check size={14} /> : <Camera size={14} />}
        {label || (url ? 'Foto enviada' : 'Foto')}
        {estado === 'erro' && <span style={{ color: '#b91c1c' }}>erro</span>}
        {/* Sem `capture`: o celular abre o seletor nativo com as DUAS opções
            (tirar foto na hora OU escolher da galeria/arquivos). Com `capture`
            forçaria só a câmera. */}
        <input type="file" accept="image/*" style={{ display: 'none' }}
          onChange={(e) => enviar(e.target.files?.[0])} />
      </label>
      {/* Botão de remover — só aparece quando já há foto enviada. Fora do
          <label> de propósito: dentro dele, o clique abriria o seletor de
          arquivo em vez de limpar. */}
      {url && estado !== 'enviando' && (
        <button type="button" onClick={remover} title="Remover foto"
          style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 24, height: 24, padding: 0, cursor: 'pointer', borderRadius: 6,
            border: '1px solid #fecaca', background: '#fef2f2', color: '#b91c1c',
          }}>
          <X size={14} />
        </button>
      )}
    </span>
  );
};

export default FotoUpload;
